module.exports = __webpack_public_path__ + "img/zaturdaylogowhite.e1be3621.png";